"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productSelectors = void 0;
const getAsin = (state) => state.asin;
const getTenant = (state) => state.tenant;
exports.productSelectors = {
    getAsin,
    getTenant
};
